app.controller("LanguagesIndexController", [
    "$scope", "StaticData", "Selection", "InfoModal", "toastr", "Language", "$uibModal", "ConfirmModal", "usSpinnerService",
    function ($scope, StaticData, Selection, InfoModal, toastr, Language, $uibModal, ConfirmModal, usSpinnerService) {
        load();

        function load(cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            Language.containersList().then(function (data) {
                $scope.containers = data;
                StaticData.getByKey("subject_seasons").then(function (data) {
                    $scope.containers.forEach(function (container) {
                        container.subjects.forEach(function (subject) {
                            var filtered = _.filter(data.data.items, function (item) {
                                return item._id == subject.season;
                            });
                            subject.seasonName = filtered.length ? filtered[0].name : '';
                        })
                    })
                });
                usSpinnerService.stop("root");
                cb();
            });
        }

        $scope.addContainer = function () {
            $uibModal.open({
                controller: "AddLanguageContainer",
                templateUrl: _pb + 'admin/languages/add-language-container.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {
                    load();
                }, function () {
                });
        };

        $scope.addSubject = function (containerId, program, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "AddSubjectToContainerController",
                templateUrl: _pb + 'admin/programs/add-subject-to-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {containerId: containerId, semesters: 12, program: program, method: Language.createSubjectWrapper};
                    }
                }
            }).result
                .then(function () {
                    load();
                }, function () {
                });
        };

        $scope.activateSubject = function (subjectWrapperId) {
            ConfirmModal.show({
                title: "საგნის აქტივაცია",
                message: "გსურთ ამ საგნის აქტივაცია?"
            }).result.then(function () {
                Selection.activate({subjectWrapperId: subjectWrapperId}).then(function (resp) {
                    if(resp.status === "success"){
                        toastr.success('',"საგანი წარმატებით გააქტიურდა");
                    } else if (resp.status === "exists") {
                        toastr.warning('',"საგანი უკვე გააქტიურებულია");
                    } else if (resp.status === "notInProgram") {
                        toastr.warning('',"საგანი არ ეკუთვნის არცერთ პროგრამას");
                    } else {
                        toastr.error('',"დაფიქსირდა სერვერის შეცდომა");
                    }
                    load();
                });
            });
        };

        $scope.editSubject = function (wrapper, program, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditSubjectWrapperController",
                templateUrl: _pb + 'admin/programs/edit-subject-to-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {wrapper: wrapper, semesters: 12, program: wrapper.program, method: Language.editSubjectWrapper};
                    }
                }
            }).result
                .then(function (result) {
                    load();
                }, function () {
                });
        };

        $scope.removeSubject = function (wrapperId) {
            ConfirmModal.show({
                title: "საგნის წაშლა",
                message: "გსურთ ამ საგნის წაშლა?"
            }).result.then(function () {
                Language.deleteSubjectWrapper({wrapperId: wrapperId}).then(load);
            });
        };

        $scope.subjectOptions = {
            editSubject: $scope.editSubject,
            removeSubject: $scope.removeSubject,
            activateSubject: $scope.activateSubject
        };

        $scope.removeContainer = function (containerId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            ConfirmModal.show({
                title: "კონტეინერის წაშლა",
                message: "გსურთ ამ კონტეინერის წაშლა?"
            }).result.then(function () {
                Language.removeContainer({containerId: containerId}).then(function (result) {
                    load();
                });
            });
        };

        $scope.editContainer = function (containerId, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditContainerController",
                templateUrl: _pb + 'admin/programs/edit-container.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {
                            containerId: containerId,
                            method: Language.updateContainer
                        };
                    }
                }
            }).result
                .then(function (result) {
                    load();
                }, function () {
                });
        };
    }
]);
